import {ViewType} from "../../gd/const/views/view-type";
import ApiView from "../../gd/api/view";
import DatetimeUtils from "../../gd/utils/datetime-utils";
import {ReportConfig} from "../report/@types";
import {ViewScope} from "../view/@const";
import ModelEntity from "../model-entity";
import isSameValue from "../../gd/utils/misc/is-same-value";
import ErrorProto from "../../gd/validation/error";
import ErrorFieldRequired from "../../gd/validation/error-field-required";

// const debug = "SavedView"
const debug = false

export default class SavedView extends ModelEntity {

    public type             : ViewType
    public createdByUserId  : ID
    public momentCreated    : Moment    // when we created report ...
    public date             : Moment    // ???
    public version          : number    // just reserve for now
    public name             : string
    public description      : string

    // Scope related
    public scope            : ViewScope
    public projectId?       : ID
    public userId?          : ID // this view related to specific user - like report

    public data             : any

    constructor(data: any) {

        super(data)
        this.id                 =   data.id
        this.data               =   data.data
        this.createdByUserId    =   data.createdByUserId
        this.momentCreated      =   DatetimeUtils.datetimeToMoment(data.momentCreated)
        this.date               =   data.date
        this.version            =   data.version
        this.type               =   data.type
        this.name               =   data.name
        this.description        =   data.description // Ego poka net v backend


        this.projectId          = data.projectId

        // patch - nado krasivee
        this.scope = ViewScope.ORGANIZATION
        if (this.projectId) {
            this.scope = ViewScope.PROJECT
        } else if (this.userId) {
            this.scope = ViewScope.USER
        }
    }

    static initFromJson(data:JSONObject):SavedView {
        return new SavedView(data)
    }

    async updateView (){
        try {
            const payload = {
                data        :   this.data,
                // date        :   moment(this.date).format("YYYY-MM-DD"),
                name        :   this.name,
                description :   this.description
            }

            await ApiView.updateView(this.id, payload).promise()
        }
        catch (e){
            console.error(e)
        }
    }

    async removeView(){
        try{
            await ApiView.deleteView(this.id).promise()
        }
        catch(e){
            console.error(e)
        }
    }

    get createdByUser():any {
        return gd.session.users.get(this.createdByUserId)
    }

    applyDelta(data:any) {
        debug && console.log(debug, "applyDelta()", data)

        let isChanged = false

        _.mapKeys(data, (value ,key)=>{
            if (key === 'id') return

            // @ts-ignore
            debug && console.log(debug, "applyDelta key=", key, !isSameValue(key, value), this[key], value)

            if (!isSameValue(this, key, value)) {

                debug && console.log(".....set", key, "neValue", value)

                switch (key) {
                    case 'name':
                        // @ts-ignore
                        this[key] = data.name; break
                    default         :
                        // @ts-ignore
                        this[key] = value
                }

                isChanged = true
            }
        })

        debug && console.log(debug, "....applyDelta isChanged", isChanged)

        return isChanged
    }

    validate():ErrorProto[] | null  {
        const errors : any[] = []

        if (!this.name) errors.push(new ErrorFieldRequired(gd.fields.savedView.name))

        if (_.isEmpty(errors)) return null
        else return errors
    }

    toJSON():JSONObject {

        const result: JSONObject = {
            id              :   this.id,
            data            :   this.data,
            createdByUserId :   this.createdByUserId,
            momentCreated   :   DatetimeUtils.momentToDate(this.momentCreated),
            date            :   this.date.format("YYYY-MM-DD"),
            version         :   this.version,
            type            :   this.type,
            name            :   this.name,
            description     :   this.description
        }

        if(this.projectId){
            result["projectId"] = this.projectId;
        }

        return result
    }

    toReportConfig():ReportConfig {
        return {
            id              : this.id,
            name            : this.name,
            description     : this.description,
            autoGenerate    : true,
            scope           : this.scope,
            settings        : this.data?.settings, // hmmm carefull - need type for this,
            savedView       : this
        }
    }
}
